'use strict';


import { createDealLabel, latLngAltToVector3, Layer } from './Layer';
import { Vector3 } from 'three';

export class Deals extends Layer{

    constructor (parent, data) {
        super(parent, data);

        return this.createLayer();
    }

    async createLayer() {

        this.data = await this.response;

        if (!this.data) {
            this.btn?.remove();
            return;
        }

        const labels = [];

        const center = {lat: Number(config.localization.latitude), lng: Number(config.localization.longitude)};
        this.data.forEach(el => {
           const splitedCoords = el.coords.split(',');
           const coords = {lat: splitedCoords[0], lng: splitedCoords[1]};
           const vector = latLngAltToVector3(coords,center);

           const label = createDealLabel(el);
           label.position.copy(vector);
           this.routeGroup.add(label);
    
            this.labels.push({
                label,
                distance: vector.distanceTo(new Vector3())
            });

           labels.push(label);
        });

        return labels;

    }

}
